/**
 * Copyright (c) 2021 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import React from 'react';
import { BlendBridge } from 'blb-types/blendBridge';

export interface InboxContextType {
  stylingConfig: {
    additionalPadding?: boolean;
    columnReplyCounts?: boolean;
    condensedDetails?: boolean;
    hideTags?: boolean;
    highlightSectionHeaders?: boolean;
    singleItemPerRow?: boolean;
    topic?: BlendBridge.API.Topic;
  };
}

export const INITIAL_INBOX_CONTEXT_VALUES = {
  stylingConfig: {},
};

export const InboxContext = React.createContext<InboxContextType>(INITIAL_INBOX_CONTEXT_VALUES);
